<template>
  <v-simple-table class="striped-table" style="border: 1px dashed #ccc">
    <template v-slot:default>
      <thead>
        <tr class="grey lighten-3">
          <th></th>
          <template v-if="item.shifts && item.shifts.length">
            <th
              v-for="shift in item.shifts"
              :key="`shift-header-${shift.shift}`"
              class="text-center font-weight-bold"
            >
              {{ $t(`shift_${shift.shift}`) }}
            </th>
          </template>
          <th class="text-center font-weight-bold">
            {{ device.isMobile ? "Σ" : $t("total") || "ukupno" }}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Food Row -->
        <tr class="orange lighten-4">
          <td class="font-weight-bold">
            {{ item.isTotal ? $t("total") : toLatin(item.food_name) }}
          </td>
          <template v-if="item.shifts && item.shifts.length">
            <td
              v-for="shift in item.shifts"
              :key="`food-shift-${shift.shift}`"
              class="text-center font-weight-bold pa-1"
            >
              <span v-if="item.isTotal">{{
                getTotalShiftQuantityForSummary(shift.shift)
              }}</span>
              <v-row v-else no-gutters justify="center">
                <text-field
                  v-model.number="shift.quantity"
                  type="number"
                  hide-details
                  class="centered-input"
                  color="white"
                  :style="device.isMobile ? 'max-width: 100px' : 'max-width: 100px'"
                  @input="$emit('recalculate-item', item)"
                />
              </v-row>
            </td>
          </template>
          <td class="text-center font-weight-bold">
            <span v-if="item.isTotal">{{ getTotalQuantityAcrossAllShifts() }}</span>
            <span v-else>{{ getTotalShiftQuantity(item.shifts) }}</span>
          </td>
        </tr>
        <!-- Groceries Rows -->
        <template v-if="item.groceries && item.groceries.length">
          <tr v-for="(gr, grIndex) in item.groceries" :key="gr.id">
            <td class="font-weight-medium">{{ gr.name }}</td>
            <template v-if="item.shifts && item.shifts.length">
              <td
                v-for="shift in item.shifts"
                :key="`gr-shift-${shift.shift}-${gr.id}`"
                class="text-center"
              >
                <template v-if="item.isTotal">
                  {{
                    gr.shifts && gr.shifts[shift.shift] > 0
                      ? gr.measure && gr.measure.toLowerCase() === "kom"
                        ? Math.round(gr.shifts[shift.shift])
                        : gr.shifts[shift.shift].toFixed(3)
                      : ""
                  }}
                </template>
                <template v-else>
                  {{
                    shift.quantity > 0
                      ? gr.measure && gr.measure.toLowerCase() === "kom"
                        ? Math.round(gr.quantity * shift.quantity)
                        : (gr.quantity * shift.quantity).toFixed(3)
                      : ""
                  }}
                </template>
              </td>
            </template>
            <td class="text-center font-weight-medium">
              <template v-if="item.isTotal">
                {{
                  gr.total > 0
                    ? gr.measure && gr.measure.toLowerCase() === "kom"
                      ? Math.round(gr.total)
                      : [gr.total.toFixed(3), gr.measure].join(" ")
                    : ""
                }}
              </template>
              <template v-else>
                {{
                  calculateTotal(gr.quantity, item.shifts, gr.measure)
                    ? [
                        calculateTotal(gr.quantity, item.shifts, gr.measure),
                        gr.measure,
                      ].join(" ")
                    : ""
                }}
              </template>
            </td>
          </tr>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "RecipeTable",
  props: {
    item: {
      type: Object,
      required: true,
    },
    allItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    calculateTotal(quantity, shifts, measure) {
      if (!shifts || !shifts.length) return "";
      const totalShiftQuantity = shifts.reduce((sum, shift) => sum + shift.quantity, 0);
      if (totalShiftQuantity <= 0) return "";
      const result = quantity * totalShiftQuantity;
      return measure && measure.toLowerCase() === "kom"
        ? Math.round(result)
        : result.toFixed(3);
    },
    getTotalShiftQuantity(shifts) {
      if (!shifts || !shifts.length) return "";
      return shifts.reduce((sum, shift) => sum + shift.quantity, 0);
    },
    getTotalShiftQuantityForSummary(shiftNumber) {
      let total = 0;
      this.allItems.forEach((item) => {
        if (item.shifts && item.shifts.length && !item.isTotal) {
          const shift = item.shifts.find((s) => s.shift === shiftNumber);
          if (shift) {
            total += shift.quantity;
          }
        }
      });
      return total || "";
    },
    getTotalQuantityAcrossAllShifts() {
      let total = 0;
      this.allItems.forEach((item) => {
        if (item.shifts && item.shifts.length && !item.isTotal) {
          item.shifts.forEach((shift) => {
            total += shift.quantity;
          });
        }
      });
      return total || "";
    },
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
  font-weight: bold;
}

.centered-input >>> .v-input__control {
  min-height: 32px;
}

.centered-input >>> .v-text-field__details {
  display: none;
}

/* Mobile styles */
@media (max-width: 960px) {
  .centered-input >>> input {
    font-size: 12px !important;
    padding: 2px 4px !important;
  }
  .centered-input >>> .v-input__slot {
    min-height: 28px !important;
    padding: 2px 4px !important;
  }

  .centered-input >>> .v-input__control {
    min-height: 28px !important;
  }
}
</style>

<style scoped>
.report-table >>> thead tr th {
  font-size: 0.875rem;
  height: 48px;
  border-bottom: 2px solid #e0e0e0 !important;
}

.report-table >>> tbody tr td {
  height: 52px;
  font-size: 0.875rem;
}

.report-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.v-breadcrumbs >>> .v-breadcrumbs__item {
  font-size: 0.875rem;
}

.centered-input >>> input {
  text-align: center;
  font-weight: bold;
}

.centered-input >>> .v-input__control {
  min-height: 32px;
}

.centered-input >>> .v-text-field__details {
  display: none;
}

/* Mobile styles */
@media (max-width: 960px) {
  .centered-input >>> input {
    font-size: 12px !important;
    padding: 2px 4px !important;
  }
  .centered-input >>> .v-input__slot {
    min-height: 28px !important;
    padding: 2px 4px !important;
  }

  .centered-input >>> .v-input__control {
    min-height: 28px !important;
  }

  .report-table >>> tbody tr td {
    padding: 4px 2px !important;
    font-size: 0.75rem !important;
  }

  .report-table >>> thead tr th {
    padding: 4px 2px !important;
    font-size: 0.75rem !important;
  }
}
</style>
